import styled from "styled-components";
import media from "constants/media";

import { RadioStyled } from "components/shared/radio/Radio.styled";
import { CardNumberInputStyled } from "components/shared/cardNumberInput/CardNumberInput.styled";

export const FormStyled = styled.div`
    margin: -155px -10px 0;
    padding: 200px 10px 50px;

    background: var(--color-white);

    ${media.mdUp`    
        max-width: 780px;
        margin: -35px auto 0;
        padding: 100px 70px 70px;
    `}

    ${CardNumberInputStyled} {
        margin: 12px 0;

        ${media.mdUp`
            margin: 20px auto;
        `};
    }
`;

export const Field = styled.div`
    margin-bottom: 24px;
`;

export const Label = styled.label`
    position: relative;

    display: block;
    margin-bottom: 16px;

    font-weight: 500;
    font-size: 14px;
    line-height: 20px;

    button {
        position: absolute;
        top: 0;
        right: 0;
    }
`;

export const SectionTitle = styled.span`
    position: relative;

    display: block;
    margin-bottom: 16px;

    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
`;

export const Options = styled.div`
    display: flex;
    align-items: center;

    ${RadioStyled} {
        max-width: 140px;
    }
`;

export const StyledLink = styled.a`
    color: var(--color-peach);
    text-decoration: underline;
`;

export const ModalContainer = styled.div`
    position: relative;

    width: 100%;
    max-width: 980px;
    min-height: 100vh;
    margin: 0 auto;
    padding: 40px 0;

    background: var(--color-white);

    ${media.mdUp`
        min-height: 0;
        padding: 0;
    `}
`;

export const Close = styled.button`
    position: absolute;
    top: 20px;
    right: 20px;

    width: 12px;

    cursor: pointer;

    svg {
        width: 100%;
    }
`;

export const Error = styled.div`
    margin-top: 3px;

    color: var(--color-red);
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap;
`;

export const Image = styled.img`
    width: 100%;
    max-width: 100%;
    max-height: 80vw;
`;
